import { PropsWithChildren } from 'react'
import css from './button.module.css'
import { ReactComponent as LeftHandIcon } from '../../asserts/icons/leftHand.svg'
import { ReactComponent as RightHandIcon } from '../../asserts/icons/rightHand.svg'

interface IProps {
  onClick?: () => void
  disabled?: boolean
  loading?: boolean
  withHands?: boolean
}

const NbmgButton = (props: PropsWithChildren<IProps>) => {
  const handleClick = () => {
    if (props.disabled || props.loading) return

    props.onClick()
  }

  return (
    <button
      className={css.button}
      onClick={handleClick}
      disabled={props.disabled ?? false}
      data-disabled={props.disabled}
      data-loading={props.loading}
    >
      {props.withHands && <LeftHandIcon className={css.leftHand} />}
      {props.withHands && <RightHandIcon className={css.rightHand} />}
      <span style={{ visibility: props.loading ? 'hidden' : 'visible' }}>{props.children}</span>
    </button>
  )
}

export default NbmgButton
